import React, {useEffect,useState,useContext,useRef} from 'react'
import { useNavigate,useLocation,useParams, Outlet } from 'react-router-dom';
import { PiTrash,PiDotsThreeVertical,PiTag, PiUsersThree,PiUsersThreeFill, PiUsersThreeLight, PiPath, PiPathFill, PiPathLight } from "react-icons/pi";
import {YesNoDialog,Scrollable,MsHeader,ContentContainer,ListItem} from 'coaz-ui';
import AddCriteriaPathItem from './AddCriteriaPathItem';
import CriteriaPathItem from './CriteriaPathItem';
import client from '../client';

const CriteriaPathItems = () => {
    const [roots,setRoots] = useState([]);
    const [deleteAuthority,setDeleteAuthority] = useState(false);
    const [buttons,setButtons] = useState([]);
    const [loading,setLoading] = useState(false);
    const {request,errorMessage} = client;
    const {currentUserId,pathId} = useParams();
    const path = useLocation().pathname;

    const navigate = useNavigate();

    const getRoots = async () => {
        await request('GET','criteria-path-items/roots')
        .then((response) => {
            if(response && response.length > 0) {
                setRoots(response);
            } else {
                setRoots([]);
            }
        })
        .catch((error) => {
            setRoots([]);
        });
    }

    const onOpen = (item) => {
        if(!item || !item.id)return;
        navigate(`${path}/_path/${item.id}`)
    }

    const load = async () => {
        !loading && setLoading(true);
        await getRoots();
        setLoading(false);
    }

    useEffect(() => {
        load();
    },[path])
  return (
    <>{pathId?
        <Outlet/>:
        <ContentContainer
            buttons={buttons} 
            Icon={PiPathLight} 
            text='Criteria Paths' 
            background={true}
            loading={loading}>
            {roots && roots.length > 0 &&
            <div className='flex flex-col w-full h-auto p-4 space-y-2'>
                <p className='w-full h-auto text-xs tracking-wider items-center text-text font-helveticaNeueMedium break-words overflow-hidden uppercase'>Roots</p>
                {roots.map((root,i) => <ListItem 
                    key={i} 
                    Icon={PiPathLight} 
                    item={{id:root.id,text:root.name}} 
                    handleOpen={onOpen}
                />)}
            </div>
            }
        </ContentContainer>
    }
    </>
  )
}

export default CriteriaPathItems